export default __webpack_public_path__ + "static/media/logo.f550df68.png";